function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import SignupWithAnimationComponent from "../signup-with-animation/signup-with-animation-component";
import { StyledCompaniesLogosComponent } from "./companies-logos-component.scss";
import { getCompaniesAssets } from "segments/desktop/core-components/logos/logos-const";
const NUMBER_OF_COMPANIES = 7;
class CompaniesLogosComponent extends PureComponent {
    renderSignupWithAnimationIfNeeded() {
        let { withAnimation, signupForm = {}, showSignup } = this.props;
        signupForm.showDecorations = false;
        return showSignup && /*#__PURE__*/ _jsx("div", {
            className: "signup-wrapper",
            children: /*#__PURE__*/ _jsx(SignupWithAnimationComponent, {
                withAnimation: withAnimation,
                signupForm: signupForm
            })
        });
    }
    render() {
        const companiesAssets = getCompaniesAssets();
        const companiesAssetsSliced = companiesAssets.slice(0, NUMBER_OF_COMPANIES);
        return /*#__PURE__*/ _jsxs(StyledCompaniesLogosComponent, {
            className: "companies-with-logos-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("paragraph-with-logos-wrapper"),
                    children: /*#__PURE__*/ _jsx(ParagraphWithLogosComponent, _object_spread_props(_object_spread({}, this.props), {
                        assets: companiesAssetsSliced
                    }))
                }),
                this.renderSignupWithAnimationIfNeeded()
            ]
        });
    }
}
export { CompaniesLogosComponent as default };
CompaniesLogosComponent.defaultProps = {
    paragraph: {
        title: "Join more than 330,000 users who manage teams better.",
        textDirection: "center"
    },
    signupForm: {},
    withAnimation: true,
    showSignup: true
};
